import React from 'react';
import ScrollReveal from './ScrollReveal';
import { trackProductCTAClick, trackDeploymentOptionClick } from '../utils/analytics';

const products = [
  {
    cls: 'pc-monitoring',
    tag: 'Subscription',
    priceLabel: 'Monthly / Annual / 3-Year',
    priceSub: 'Per Site',
    title: 'Vision Monitoring',
    desc: 'Core operational visibility layer \u2014 real-time activity tracking, occupancy metrics, and KPI dashboards for baseline transparency.',
    features: [
      'Edge AI hardware & on-site deployment included',
      'Real-time activity counts & occupancy metrics',
      'Entry/exit volume & time-of-day heatmaps',
      'KPI dashboards & multi-site visibility',
      'Up to 3 dashboard customizations per year per site',
    ],
    bestFor: ['Operational Oversight', 'Remote Staff Mgmt', 'Governance Reporting'],
  },
  {
    cls: 'pc-insights',
    tag: 'Subscription',
    priceLabel: 'Monthly / Annual / 3-Year',
    priceSub: 'Per Site',
    title: 'Vision Insights',
    desc: 'Advanced analytics layer \u2014 everything in Monitoring plus AI scene analytics, demographic bands, behavioral patterns, and trend modeling.',
    includesBadge: 'Includes everything in Vision Monitoring',
    features: [
      'Edge AI hardware & on-site deployment included',
      'Advanced AI scene analytics & trend modeling',
      'Aggregate demographic bands & behavioral patterns',
      'Comparative site benchmarking & forecasting',
      'Enhanced reporting depth & custom analytics',
    ],
    bestFor: ['Impact Reporting', 'Donor Dashboards', 'Strategic Decision Support'],
  },
];

const deploymentOptions = [
  {
    title: 'Single Site Pilot',
    desc: 'Baseline visibility for one facility with Monitoring or Insights.',
  },
  {
    title: 'Full Analytics',
    desc: 'Complete intelligence with Insights, benchmarking, and forecasting.',
    featured: true,
  },
  {
    title: 'Multi-Site Rollout',
    desc: 'Scaled deployment across facilities with centralized oversight.',
  },
];

const scrollToContact = () => {
  const el = document.getElementById('contact');
  if (el) el.scrollIntoView({ behavior: 'smooth' });
};

export default function Solutions() {
  return (
    <section className="section" id="solutions">
      <div className="section-inner">
        <div className="section-label">Solutions</div>
        <ScrollReveal>
          <h2 className="section-title">
            Hardware + Software.<br /><strong>One integrated platform.</strong>
          </h2>
        </ScrollReveal>
        <ScrollReveal>
          <p className="section-subtitle">
            From edge device deployment to real-time operational dashboards &mdash; everything you
            need to convert camera infrastructure into structured intelligence.
          </p>
        </ScrollReveal>

        <div className="products-grid">
          {products.map((p) => (
            <ScrollReveal key={p.cls}>
              <div className={`product-card ${p.cls}`}>
                <div className="product-card-header">
                  <div className="product-card-tag">{p.tag}</div>
                  <div className="product-card-price">
                    <strong>{p.priceLabel}</strong>{p.priceSub}
                  </div>
                </div>
                <h3>{p.title}</h3>
                <p className="product-card-desc">{p.desc}</p>
                {p.includesBadge && (
                  <div className="product-includes-badge">{p.includesBadge}</div>
                )}
                <ul className="product-features">
                  {p.features.map((f, i) => <li key={i}>{f}</li>)}
                </ul>
                {p.bestFor && (
                  <div className="product-best-for">
                    <div className="product-best-for-label">Best For</div>
                    <div className="product-best-for-tags">
                      {p.bestFor.map((t) => <span className="best-tag" key={t}>{t}</span>)}
                    </div>
                  </div>
                )}
                <button className="btn-primary product-cta" onClick={() => { trackProductCTAClick(p.title.toLowerCase().replace(/\s+/g, '_')); scrollToContact(); }}>
                  Request a Demo
                </button>
              </div>
            </ScrollReveal>
          ))}
        </div>

        {/* Deployment Options Strip */}
        <ScrollReveal>
          <div className="deploy-strip">
            <div className="deploy-strip-label">Deployment Options</div>
            <div className="deploy-strip-options">
              {deploymentOptions.map((opt) => (
                <button
                  key={opt.title}
                  className={`deploy-option${opt.featured ? ' featured' : ''}`}
                  onClick={() => { trackDeploymentOptionClick(opt.title.toLowerCase().replace(/\s+/g, '_')); scrollToContact(); }}
                >
                  <span className="deploy-option-title">{opt.title}</span>
                  <span className="deploy-option-desc">{opt.desc}</span>
                </button>
              ))}
            </div>
          </div>
        </ScrollReveal>
      </div>
    </section>
  );
}
